{
  "name": "mt-ascup-pwa",
  "version": "1.55.0",
  "repository": {
    "type": "git",
    "url": "git@gitlab.mosmetro.tech:ctr/ascup/frontend/mt_ascup_pwa.git"
  },
  "engines": {
    "node": "^20.11.1"
  },
  "scripts": {
    "ng": "ng",
    "prestart": "node tools/runtime-config.mjs public/runtime-config.json local",
    "start": "ng serve --open --configuration=local --port=5202",
    "prestart:dev": "node tools/runtime-config.mjs public/runtime-config.json dev",
    "start:dev": "ng serve --open --configuration=local --port=5202",
    "prestart:exp": "node tools/runtime-config.mjs public/runtime-config.json",
    "start:exp": "ng serve --open --configuration=exp --port=5202",
    "prestart:lan": "node tools/runtime-config.mjs public/runtime-config.json local",
    "start:lan": "ng serve --configuration=local --host=0.0.0.0 --port=5202 --disable-host-check",
    "prebuild": "node tools/runtime-config.mjs",
    "build": "ng build",
    "build:isolated": "node tools/runtime-config.mjs public/runtime-config.json local && ng build --configuration=isolated",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:headless": "HEADLESS=true ng test --code-coverage",
    "test:ci": "CI=true ng test --code-coverage",
    "install-local-lib": "npm i ngx-mt-ui-lib@file:../ngx-mt-ui-lib/dist/ngx-mt-ui-lib --no-save --prefer-online",
    "start:local-lib": "ng cache clean && npm run install-local-lib && npm run start",
    "lint": "ng lint",
    "format": "prettier --write src",
    "format:check": "prettier --check src",
    "prepare": "husky",
    "prestart:isolated": "node tools/runtime-config.mjs public/runtime-config.json local",
    "start:isolated": "ng serve --configuration=isolated",
    "config:runtime": "node tools/runtime-config.mjs",
    "test:tools": "node --test tools/runtime-config.test.mjs"
  },
  "prettier": {
    "tabWidth": 2,
    "useTabs": false,
    "htmlWhitespaceSensitivity": "strict",
    "bracketSameLine": true,
    "singleAttributePerLine": true,
    "singleQuote": true
  },
  "lint-staged": {
    "*.{ts,js,html,css,scss,json,md}": [
      "prettier --write"
    ],
    "*.{ts,js,html}": [
      "eslint --fix"
    ]
  },
  "private": true,
  "overrides": {
    "@ngx-translate/core": "^18.0.0"
  },
  "dependencies": {
    "@angular/animations": "^19.2.25",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "^19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/forms": "^19.2.25",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@angular/service-worker": "^19.2.25",
    "@lucide/angular": "^1.22.0",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/entity": "^19.2.1",
    "@ngrx/operators": "^19.2.1",
    "@ngrx/signals": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@panzoom/panzoom": "^4.6.1",
    "@stomp/rx-stomp": "^2.4.0",
    "@tiptap/core": "^3.26.0",
    "@tiptap/extension-color": "^3.27.1",
    "@tiptap/extension-text-style": "^3.27.1",
    "@tiptap/markdown": "^3.27.1",
    "@tiptap/pm": "^3.27.1",
    "@tiptap/starter-kit": "^3.27.1",
    "@tiptap/suggestion": "^3.27.1",
    "ag-grid-angular": "^34.3.1",
    "ag-grid-community": "^34.3.1",
    "dayjs": "^1.11.19",
    "echarts": "^6.1.0",
    "ias-ppr-mt-chat-client": "0.10.4",
    "keycloak-js": "26.2.4",
    "lucide-static": "^1.7.0",
    "micromark": "^4.0.2",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-mask": "^19.0.7",
    "ngx-mt-ui-lib": "^19.52.0",
    "ngx-quicklink": "^0.4.7",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.27",
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.2.25",
    "@ngrx/schematics": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/gitlab": "^13.2.9",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "@typescript-eslint/types": "^7.18.0",
    "@typescript-eslint/utils": "^7.18.0",
    "eslint": "^8.57.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.11",
    "prettier": "^3.8.1",
    "semantic-release": "^24.2.9",
    "typescript": "~5.8.3"
  }
}
